import * as React from "react";
import "./OptionsDialog.component.css";
import { GenericDialog } from "../generic-dialog/GenericDialog.component";
import { GeneralSettings } from "./general-settings/GeneralSettings.component";
import { AudioSettings } from "../../components/device-settings/audio-settings/AudioSettings.component";
import { CameraSelect } from "../../components/device-settings/camera-select/CameraSelect.component";
import { ControlsSettings } from "./controls-settings/ControlsSettings.component";
import { DeveloperSettings } from "./developer-settings/DeveloperSettings.component";
import { useRef, useState } from "react";
import { GraphicsSettings } from "./graphics-settings/GraphicsSettings.component";
import { AvatarEditor } from "../../components/avatar-editor/AvatarEditor.component";
import { useTranslation } from "react-i18next";
var OptionsDialogTab;
(function (OptionsDialogTab) {
    OptionsDialogTab[OptionsDialogTab["general"] = 0] = "general";
    OptionsDialogTab[OptionsDialogTab["audioSettings"] = 1] = "audioSettings";
    OptionsDialogTab[OptionsDialogTab["videoSettings"] = 2] = "videoSettings";
    OptionsDialogTab[OptionsDialogTab["avatar"] = 3] = "avatar";
    OptionsDialogTab[OptionsDialogTab["controls"] = 4] = "controls";
    OptionsDialogTab[OptionsDialogTab["graphics"] = 5] = "graphics";
    OptionsDialogTab[OptionsDialogTab["devSettings"] = 6] = "devSettings";
})(OptionsDialogTab || (OptionsDialogTab = {}));
const settingsTabs = [
    OptionsDialogTab.general,
    OptionsDialogTab.audioSettings,
    OptionsDialogTab.videoSettings,
    OptionsDialogTab.avatar,
    OptionsDialogTab.controls,
    OptionsDialogTab.graphics,
    OptionsDialogTab.devSettings
];
export function OptionsDialog(_a) {
    var _b;
    var { onClose, username = (_b = localStorage.getItem("username")) !== null && _b !== void 0 ? _b : "Guest" } = _a;
    const [currentTab, setCurrentTab] = useState(OptionsDialogTab.general);
    const tabRefs = useRef([]);
    const { t } = useTranslation();
    const getCurrentSettingsComponent = () => {
        switch (currentTab) {
            case OptionsDialogTab.general:
                return React.createElement(GeneralSettings, null);
            case OptionsDialogTab.audioSettings:
                return React.createElement(AudioSettings, null);
            case OptionsDialogTab.videoSettings:
                return React.createElement(CameraSelect, null);
            case OptionsDialogTab.avatar:
                return React.createElement(AvatarEditor, { username: username });
            case OptionsDialogTab.controls:
                return React.createElement(ControlsSettings, null);
            case OptionsDialogTab.graphics:
                return React.createElement(GraphicsSettings, null);
            case OptionsDialogTab.devSettings:
                return React.createElement(DeveloperSettings, null);
        }
    };
    const getSettingsTitle = (tab) => {
        switch (tab) {
            case OptionsDialogTab.general:
                return t("settings:tab-general", "General");
            case OptionsDialogTab.audioSettings:
                return t("settings:tab-audio", "Audio");
            case OptionsDialogTab.videoSettings:
                return t("settings:tab-video", "Video");
            case OptionsDialogTab.avatar:
                return t("settings:tab-avatar", "Avatar");
            case OptionsDialogTab.controls:
                return t("settings:tab-controls", "Controls");
            case OptionsDialogTab.graphics:
                return t("settings:tab-graphics", "Graphics");
            case OptionsDialogTab.devSettings:
                return t("settings:tab-expert", "Expert");
        }
    };
    const createSettingsNavItem = (tab) => {
        const tabIndex = settingsTabs.indexOf(tab);
        const selected = currentTab === tab;
        return (React.createElement("button", { type: "button", role: "tab", id: `options-tab-${tab}`, "aria-selected": selected, "aria-controls": "options-tabpanel", tabIndex: selected ? 0 : -1, className: `options-dialog-sidebar-item ${currentTab === tab ? "options-dialog-sidebar-item-selected" : ""} `, ref: (element) => {
                tabRefs.current[tabIndex] = element;
            }, onClick: () => {
                setCurrentTab(tab);
            } }, getSettingsTitle(tab)));
    };
    return (React.createElement(GenericDialog, { title: t("settings:dialog-title", "Settings"), onConfirm: onClose, onCancel: onClose, confirmText: t("settings:dialog-close-button", "Close"), hideCancel: true, width: "medium", height: "tall", noContentPadding: true, minWidth: 900, maxWidth: 1200 },
        React.createElement("div", { className: "options-dialog-container" },
            React.createElement("aside", { className: "options-dialog-sidebar", role: "tablist", "aria-label": t("settings:tab-navigation-label", "Settings sections"), "aria-orientation": "vertical" },
                createSettingsNavItem(OptionsDialogTab.general),
                createSettingsNavItem(OptionsDialogTab.audioSettings),
                createSettingsNavItem(OptionsDialogTab.videoSettings),
                createSettingsNavItem(OptionsDialogTab.avatar),
                createSettingsNavItem(OptionsDialogTab.controls),
                createSettingsNavItem(OptionsDialogTab.graphics),
                createSettingsNavItem(OptionsDialogTab.devSettings)),
            React.createElement("main", { className: "options-dialog-main", id: "options-tabpanel", role: "tabpanel", "aria-labelledby": `options-tab-${currentTab}`, tabIndex: 0 }, getCurrentSettingsComponent()))));
}
